<template>
	<device-widget :status="level" name="Light" :node="node" />
</template>

<script>
import DeviceWidget from "../../../shared/DeviceWidget";
import _ from "lodash";

export default {
	components: { DeviceWidget },

	props: {
		node: {
			type: Object,
			required: true,
		},
	},

	computed: {
		level() {
			const level = this.node.variables.level;
			return (_.isNil(level) ? "--" : level) + "%";
		},
	},
};
</script>
